/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentDto } from '../../models/payment-dto';

export interface PaymentControllerFindById$Params {
  id: string;
}

export function paymentControllerFindById(http: HttpClient, rootUrl: string, params: PaymentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentDto>> {
  const rb = new RequestBuilder(rootUrl, paymentControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaymentDto>;
    })
  );
}

paymentControllerFindById.PATH = '/api/payment/{id}';
